(() => {
  const controllers = new Map();
  // The poster is set as the film nears the viewport rather than in the
  // markup: a poster attribute downloads at page load even with
  // preload="none", which put a 121 KiB JPEG far below the fold into the
  // initial load (PageSpeed 2026-09-30).
  function lazyPoster(video) {
    if (!video || !video.dataset.poster || video.getAttribute('poster')) return;
    const set = () => { video.poster = video.dataset.poster; };
    if (!('IntersectionObserver' in window)) return set();
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      set();
    }, { rootMargin: '1000px 0px' });
    observer.observe(video);
  }
  function initialize(root) {
    root.querySelectorAll('[data-longevity-film]').forEach(panel => {
      if (controllers.has(panel)) return;
      const video = panel.querySelector('video');
      lazyPoster(video);
      const toggle = panel.querySelector('button');
      if (!video || !toggle) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let manuallyPaused = reduced.matches;
      let visible = false;
      const sync = () => {
        toggle.classList.toggle('is-playing', !video.paused);
        toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      };
      const play = () => {
        if (!visible || manuallyPaused || document.hidden) return;
        const attempt = video.play();
        if (attempt?.catch) attempt.catch(sync);
      };
      const click = () => {
        manuallyPaused = !video.paused;
        if (manuallyPaused) video.pause();
        else { visible = true; play(); }
      };
      const motion = () => {
        if (reduced.matches) { manuallyPaused = true; video.pause(); }
        sync();
      };
      const visibility = () => {
        if (document.hidden) video.pause();
        else play();
      };
      video.controls = false;
      video.muted = true;
      toggle.hidden = false;
      toggle.addEventListener('click', click);
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      reduced.addEventListener('change', motion);
      document.addEventListener('visibilitychange', visibility);
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting);
          if (visible) play();
          else video.pause();
        }, { threshold: 0.1 });
        observer.observe(panel);
      } else { visible = true; play(); }
      sync();
      controllers.set(panel, () => {
        observer?.disconnect();
        video.pause();
        toggle.removeEventListener('click', click);
        video.removeEventListener('play', sync);
        video.removeEventListener('pause', sync);
        reduced.removeEventListener('change', motion);
        document.removeEventListener('visibilitychange', visibility);
        controllers.delete(panel);
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [panel, destroy] of controllers) {
      if (event.target.contains(panel)) destroy();
    }
  });
})();
